module.exports = __webpack_public_path__ + "static/img/4.459dc5a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/client/4.jpg
// module id = mqcr
// module chunks = 1